import useRestoreTimer from "src/hooks/useRestoreTimer";

export default function useRestoreFlightTimer(session?: { startedAt: number; maxTime: number }) {
  useRestoreTimer(session);
}
